//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.InspectionListQuery_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.InspectionListQuery_VariablesAdapter
import com.wintermar.inspection.graphql.selections.InspectionListQuerySelections
import com.wintermar.inspection.graphql.type.GetInspectionListQueryInput
import com.wintermar.inspection.graphql.type.InspectionStatus
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public data class InspectionListQuery(
  public val `param`: GetInspectionListQueryInput,
) : Query<InspectionListQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    InspectionListQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = InspectionListQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = InspectionListQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(InspectionListQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val inspectionList: InspectionList,
  ) : Query.Data

  public data class InspectionList(
    public val `data`: List<Data1>?,
    public val totalCount: Int,
  )

  public data class Data1(
    public val id: Any,
    public val templateId: Any,
    public val inspectionName: String,
    public val vesselName: String,
    public val conductedAt: Any,
    public val lastUpdatedAt: Any?,
    public val status: InspectionStatus,
    public val totalQuestions: Int,
    public val answeredQuestions: Int,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "65174f20afa99f13ee128668c99e85f20085b64bb758bd1d5780b384d1288f4c"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query inspectionList($param: GetInspectionListQueryInput!) {
     *   inspectionList(query: $param) {
     *     data {
     *       id
     *       templateId
     *       inspectionName
     *       vesselName
     *       conductedAt
     *       lastUpdatedAt
     *       status
     *       totalQuestions
     *       answeredQuestions
     *     }
     *     totalCount
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query inspectionList(${'$'}param: GetInspectionListQueryInput!) { inspectionList(query: ${'$'}param) { data { id templateId inspectionName vesselName conductedAt lastUpdatedAt status totalQuestions answeredQuestions } totalCount } }"

    public const val OPERATION_NAME: String = "inspectionList"
  }
}
